export const Error500Image = () => (
  <svg width={138} height={120} xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#031D44"
        strokeWidth={2}
        strokeLinecap="round"
        d="M100.778 14.926l-6.585 14.317-3.908-3.857-4.318 10.54M44.75 15.173l8.052 10.483-5.417 1.744 8.459 10.044M70.284 31.527l-3.723-15.362 9.09 2.136-3.77-17.64"
      />
      <path
        d="M130.869 75.041l-.595 3.375c-2.523 14.31-16.17 23.865-30.481 21.342l-17.927-3.161 9.732-55.198 17.928 3.162c14.31 2.522 23.866 16.169 21.343 30.48M7.775 78.892l-.595-3.375c-2.523-14.31 7.032-27.957 21.343-30.48l17.928-3.161 9.733 55.198-17.93 3.16c-14.31 2.524-27.956-7.031-30.48-21.342"
        fill="#e9f0fa"
      />
      <path
        stroke="#031D44"
        strokeWidth={2}
        strokeLinecap="round"
        d="M44.287 58.306l18.498-3.262M48.486 82.12l18.499-3.262"
      />
      <path
        d="M2.927 119.97a2.5 2.5 0 01-2.5-2.5v-16.506c0-11.577 9.313-22.592 21.203-25.078a2.5 2.5 0 011.024 4.894C12.993 82.8 5.427 91.665 5.427 100.964v16.506a2.5 2.5 0 01-2.5 2.5M135.716 119.97a2.5 2.5 0 01-2.5-2.5v-16.506c0-9.562-9.448-19.075-17.184-20.155a2.5 2.5 0 01.692-4.952c9.938 1.388 21.492 12.657 21.492 25.107v16.506a2.5 2.5 0 01-2.5 2.5"
        fill="#e9f0fa"
      />
    </g>
  </svg>
);
